import React, { useEffect, useState } from 'react';
import {
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  FormHelperText
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

function MaskingTextBox(props) {

  const { cssclass, required, errors, codeIsVerified,
    handleOnChange, name, isDisabled, label, value } = props;

  const [realText, setRealText] = useState('');
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    if (value) {
      setRealText(value);
    }
  }, [value])

  const handleToggle = () => {
    setShowText(prev => !prev);
  };

  const handleChange = (e) => {
    // Always update realText from typed value, not from masked version
    const newValue = e.target.value;

    // If showing real text, update directly
    if (showText) {
      setRealText(newValue);
      handleOnChange(newValue);
    } else {
      // If masked, ignore input changes (or handle smart diffing logic)
      // Optional: allow updates only if user is adding/removing 1 character
      const addedChar = newValue.length > realText.length;
      if (addedChar) {
        setRealText(realText + newValue[newValue.length - 1]);
        handleOnChange(realText + newValue[newValue.length - 1]);
      } else {
        setRealText(realText.slice(0, -1));
        handleOnChange(realText.slice(0, -1));
      }
    }
  };

  const getDisplayValue = () => {
    return showText ? realText : '*'.repeat(realText.length);
  };

  return (
    <FormControl variant="outlined"
      fullWidth
      error={errors[name] ? true : false}
      disabled={isDisabled}
      required={required}
      className={`${cssclass}`}
    >
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <OutlinedInput
        id={name}
        name={name}
        label={label}
        value={getDisplayValue()}
        onChange={handleChange}
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={handleToggle} edge="end" disabled={!codeIsVerified}>
              {showText ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
      />
      {!errors[name] && <FormHelperText>{errors[name]}</FormHelperText>}
    </FormControl>
  );
}

export default MaskingTextBox;
